<div class="branding-editor">
  <!-- Status Message -->
  @if (statusMessage()) {
  <div class="status-message" [class.success]="isSuccessStatus()" [class.error]="isErrorStatus()">
    {{ statusMessage() }}
  </div>
  }

  <!-- Loading State -->
  @if (isLoading()) {
  <div class="loading-state">
    <div class="spinner"></div>
    <p>Loading branding configuration...</p>
  </div>
  } @else {
  <!-- Branding Configuration Form -->
  <form [formGroup]="brandingForm" class="branding-form">

    <!-- Login Page Branding Section -->
    <div class="form-section">
      <h3>Login Page Branding</h3>
      <p class="section-description">Upload background image and company logo for the login page.</p>

      <div class="branding-assets-grid">
        <!-- Login Background Image Upload (Left) -->
        <div class="form-group">
          <label for="loginBackgroundImageUpload">Login Background Image (PNG, JPG - Max 1 MB)</label>
          <div class="file-upload-group">
            <input type="file" id="loginBackgroundImageUpload" #loginBackgroundImageInput accept=".png,.jpg,.jpeg"
              (change)="onLoginBackgroundImageSelected($event)" class="file-input" style="display: none;">
            @if (loginBackgroundImageUrl()) {
            <div class="asset-preview">
              <div class="preview-content">
                <img [src]="loginBackgroundImageUrl()" alt="Login background preview" class="login-bg-preview">
                @if (loginBackgroundImageFileName()) {
                <p class="file-name">{{ loginBackgroundImageFileName() }}</p>
                }
              </div>
              <div class="button-group">
                <button type="button" class="btn btn-upload" (click)="loginBackgroundImageInput.click()" title="Upload login background image" aria-label="Upload login background image">
                  <svg class="icon-upload" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
                    <path d="M13 2v7h7"/>
                    <path d="M12 15v-4"/>
                    <path d="M9 14l3-3 3 3"/>
                  </svg>
                </button>
                <button type="button" class="btn btn-remove" (click)="clearLoginBackgroundImage()" title="Remove login background image" aria-label="Remove login background image">
                  <svg class="icon-trash" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#dc2626" d="M19 6h-3V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1H5a1 1 0 0 0 0 2h1v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8h1a1 1 0 0 0 0-2zM9 5h6v1H9V5zm6 14H9V8h6v11zm-2-8a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1zm-4 0a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1z"/>
                  </svg>
                </button>
              </div>
            </div>
            } @else {
            <button type="button" class="btn btn-upload" (click)="loginBackgroundImageInput.click()" title="Upload login background image" aria-label="Upload login background image">
              <svg class="icon-upload" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
                <path d="M13 2v7h7"/>
                <path d="M12 15v-4"/>
                <path d="M9 14l3-3 3 3"/>
              </svg>
            </button>
            }
          </div>
        </div>

      </div>
    </div>

    <!-- Branding Assets Section -->
    <div class="form-section">
      <h3>Branding Assets</h3>
      <p class="section-description">Upload logo and favicon images for your portal.</p>

      <div class="branding-assets-grid">
        <!-- Logo Upload (Left) -->
        <div class="form-group">
          <label for="logoUpload">Logo (PNG, JPG - Max 1 MB)</label>
          <div class="file-upload-group">
            <input type="file" id="logoUpload" #logoInput accept=".png,.jpg,.jpeg"
              (change)="onLogoSelected($event)" class="file-input" style="display: none;">
            @if (logoUrl()) {
            <div class="asset-preview">
              <div class="preview-content">
                <img [src]="logoUrl()" alt="Logo preview" class="logo-preview">
                @if (logoFileName()) {
                <p class="file-name">{{ logoFileName() }}</p>
                }
              </div>
              <div class="button-group">
                <button type="button" class="btn btn-upload" (click)="logoInput.click()" title="Upload logo" aria-label="Upload logo">
                  <svg class="icon-upload" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
                    <path d="M13 2v7h7"/>
                    <path d="M12 15v-4"/>
                    <path d="M9 14l3-3 3 3"/>
                  </svg>
                </button>
                <button type="button" class="btn btn-remove" (click)="clearLogo()" title="Remove logo" aria-label="Remove logo">
                  <svg class="icon-trash" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#dc2626" d="M19 6h-3V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1H5a1 1 0 0 0 0 2h1v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8h1a1 1 0 0 0 0-2zM9 5h6v1H9V5zm6 14H9V8h6v11zm-2-8a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1zm-4 0a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1z"/>
                  </svg>
                </button>
              </div>
            </div>
            } @else {
            <button type="button" class="btn btn-upload" (click)="logoInput.click()" title="Upload logo" aria-label="Upload logo">
              <svg class="icon-upload" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
                <path d="M13 2v7h7"/>
                <path d="M12 15v-4"/>
                <path d="M9 14l3-3 3 3"/>
              </svg>
            </button>
            }
          </div>
        </div>

        <!-- Favicon Upload (Right) -->
        <div class="form-group">
          <label for="faviconUpload">Favicon (ICO - Max 1 MB)</label>
          <div class="file-upload-group">
            <input type="file" id="faviconUpload" #faviconInput accept=".ico"
              (change)="onFaviconSelected($event)" class="file-input" style="display: none;">
            @if (faviconUrl()) {
            <div class="asset-preview">
              <div class="preview-content">
                <img [src]="faviconUrl()" alt="Favicon preview" class="favicon-preview">
                @if (faviconFileName()) {
                <p class="file-name">{{ faviconFileName() }}</p>
                }
              </div>
              <div class="button-group">
                <button type="button" class="btn btn-upload" (click)="faviconInput.click()" title="Upload favicon" aria-label="Upload favicon">
                  <svg class="icon-upload" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                    <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
                    <path d="M13 2v7h7"/>
                    <path d="M12 15v-4"/>
                    <path d="M9 14l3-3 3 3"/>
                  </svg>
                </button>
                <button type="button" class="btn btn-remove" (click)="clearFavicon()" title="Remove favicon" aria-label="Remove favicon">
                  <svg class="icon-trash" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                    <path fill="#dc2626" d="M19 6h-3V5a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v1H5a1 1 0 0 0 0 2h1v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V8h1a1 1 0 0 0 0-2zM9 5h6v1H9V5zm6 14H9V8h6v11zm-2-8a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1zm-4 0a1 1 0 0 0-1 1v4a1 1 0 0 0 2 0v-4a1 1 0 0 0-1-1z"/>
                  </svg>
                </button>
              </div>
            </div>
            } @else {
            <button type="button" class="btn btn-upload" (click)="faviconInput.click()" title="Upload favicon" aria-label="Upload favicon">
              <svg class="icon-upload" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round">
                <path d="M13 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V9z"/>
                <path d="M13 2v7h7"/>
                <path d="M12 15v-4"/>
                <path d="M9 14l3-3 3 3"/>
              </svg>
            </button>
            }
          </div>
        </div>
      </div>
    </div>

    <!-- Theme Color Section -->
    <div class="form-section">
      <h3>Theme Colour</h3>
      <p class="section-description">Choose the theme colour that will be used throughout the portal.</p>

      <!-- Custom Color Input -->
      <div class="form-group">
        <label for="themeColour">Theme Colour</label>
        <div class="color-input-group">
          <input type="color" id="themeColour" class="color-picker" [value]="brandingForm.get('themeColour')?.value || '#2563eb'"
            (input)="onThemeColourPickerInput($event)" (blur)="markFieldAsTouched('themeColour')">
          <input type="text" formControlName="themeColour" class="color-text-input" placeholder="#2563eb"
            pattern="^#[0-9A-Fa-f]{6}$" (blur)="markFieldAsTouched('themeColour')">
        </div>
      </div>
    </div>

    <!-- Font Family Section -->
    <div class="form-section">
      <h3>Font Family</h3>
      <p class="section-description">Choose the font family (standard web-safe font or google font) that will be used throughout the portal.</p>

      <!-- Font Family Input -->
      <div class="form-group">
        <label for="fontFamily">Font Family</label>
        <input type="text" id="fontFamily" formControlName="fontFamily" class="form-control"
          placeholder="Lato, Arial, sans-serif"
          maxlength="100" (blur)="markFieldAsTouched('fontFamily')">
        <div class="form-help">
          Examples: "Roboto, sans-serif", "Georgia, serif", "Courier New, monospace"
        </div>
      </div>
    </div>

    <!-- Font Color Section -->
    <div class="form-section">
      <h3>Text Colour</h3>
      <p class="section-description">Choose the text colour that will be used throughout the portal.</p>

      <div class="form-group">
        <label for="fontColour">Text Colour</label>
        <div class="color-input-group">
          <input type="color" id="fontColour" class="color-picker" [value]="brandingForm.get('fontColour')?.value || '#2c3e5a'"
            (input)="onFontColourPickerInput($event)" (blur)="markFieldAsTouched('fontColour')">
          <input type="text" formControlName="fontColour" class="color-text-input" placeholder="#2c3e5a"
            pattern="^#[0-9A-Fa-f]{6}$" (blur)="markFieldAsTouched('fontColour')">
        </div>
      </div>
    </div>

    <!-- Action Buttons -->
    <div class="form-actions primary-actions">
      @if (hasUnsavedChanges()) {
      <span class="unsaved-indicator">● Unsaved changes</span>
      }

      <button type="button" class="btn btn-secondary" (click)="cancelChanges()"
        [disabled]="isLoading() || isSaving()">
        Cancel
      </button>

      <button type="button" class="btn btn-primary" (click)="saveBrandingConfig()"
        [disabled]="brandingForm.invalid || isSaving()">
        @if (isSaving()) {
        <span class="spinner-small"></span>
        Saving...
        } @else {
        Save Changes
        }
      </button>
    </div>
  </form>
  }
</div>
